import { parseApiDate } from './parseApiDate';

export function relativeTime(iso) {
  if (!iso) return '';
  const d = parseApiDate(iso);
  if (!d || Number.isNaN(d.getTime())) return '';
  const now = Date.now();
  const diff = Math.floor((now - d.getTime()) / 1000);
  if (diff < 10) return 'just now';
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function fullDateTime(iso) {
  if (!iso) return '';
  const d = parseApiDate(iso);
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleString();
}
